module.exports = __webpack_public_path__ + "img/5g-drone.91e858ed.svg";